import { call, takeEvery } from 'redux-saga/effects'
import { LOCATION_CHANGE } from 'react-router-redux'

import {
	appCreateFailure,
	appUpdateFailure,
	submissionCreateFailure,
	submissionCancelFailure
} from '../actions'
import { waitForState } from 'utils'

function* sendPageviewToAmplitude({ payload }) {
	yield call(() => {
		const amplitude = window.amplitude || {}
		const { pathname } = payload
		const elements = pathname.split('/')
		const name =
			'pageview.' +
			(elements[1] ? elements[1] : 'home') +
			(elements[2] && !elements[3]
				? '.overview'
				: elements[3] ? '.' + elements[3] : '')

		const params =
			elements[1] === 'apps' && elements[2]
				? {
						appId: elements[2]
					}
				: undefined
		amplitude.logEvent(name, params)
	})
}

function* sendErrorToAmplitude({ type, payload }) {
	yield call(() => {
		const amplitude = window.amplitude || {}
		const { error: { message } } = payload
		const name = 'error'
		const params = {
			type,
			message: message || null
		}
		amplitude.logEvent(name, params)
	})
}

export function* watchStatsRequests() {
	const userLogin = yield call(waitForState, state => state.user.meta.login)
	const productId = process.env.REACT_APP_PRODUCT_ID || ''
	const amplitude = window.amplitude || {}
	const identify = new amplitude.Identify().setOnce('productId', productId)

	yield call(() => {
		new Promise((resolve, reject) => {
			amplitude.getInstance().init(
				process.env.REACT_APP_AMPLITUDE_KEY,
				userLogin,
				{
					includeUtm: true
				},
				resolve
			)
		})
	})

	yield call(() => {
		amplitude.getInstance().identify(identify)
	})

	yield takeEvery(LOCATION_CHANGE, sendPageviewToAmplitude)
	yield takeEvery(
		[
			appCreateFailure,
			appUpdateFailure,
			submissionCreateFailure,
			submissionCancelFailure
		],
		sendErrorToAmplitude
	)
}



// WEBPACK FOOTER //
// ./src/sagas/stats.js